module.exports = __webpack_public_path__ + "img/20200102154110594.bd95cb0a.jpg";